import PropTypes from "prop-types";
import { Box, TableCell, TableHead, TableRow } from "@mui/material";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import React from "react";

const headCells = [
  // {
  //   id: "meterialCode",
  //   numeric: true,
  //   disablePadding: true,
  //   disableSorting: true,
  //   label: "Material code",
  // },
  {
    id: "meterialDescription",
    numeric: false,
    disableSorting: true,
    disablePadding: false,
    label: "Material description",
  },
  // {
  //   id: "plantCode",
  //   numeric: true,
  //   disablePadding: false,
  //   disableSorting: true,
  //   label: "Plant code",
  // },
  {
    id: "poItemNumber",
    numeric: true,
    disablePadding: false,
    disableSorting: true,
    label: "Po item number",
  },
  {
    id: "poDate",
    numeric: true,
    disablePadding: false,
    disableSorting: true,
    label: "Po date",
  },
  // {
  //   id: "goodsReceiptNo",
  //   numeric: true,
  //   disablePadding: false,
  //   disableSorting: true,
  //   label: "Goods receipt No",
  // },
  // {
  //   id: "goodsreceiptDate",
  //   numeric: true,
  //   disablePadding: false,
  //   disableSorting: true,
  //   label: "Goods receipt date",
  // },
  // {
  //   id: "inspectionRequestNo",
  //   numeric: true,
  //   disablePadding: false,
  //   disableSorting: true,
  //   label: "Inspection Request No",
  // },
  // {
  //   id: "inspectionNo",
  //   numeric: true,
  //   disablePadding: false,
  //   disableSorting: true,
  //   label: "Inspection No",
  // },
  // {
  //   id: "inspectionDate",
  //   numeric: true,
  //   disablePadding: false,
  //   disableSorting: true,
  //   label: "Inspection Date",
  // },
  // {
  //   id: "inspectionQuality",
  //   numeric: true,
  //   disablePadding: false,
  //   disableSorting: true,
  //   label: "Inspection quantity",
  // },
  {
    id: "invoiceDate",
    numeric: true,
    disablePadding: false,
    disableSorting: true,
    label: "Invoice date",
  },
  {
    id: "paymentDocument",
    numeric: false,
    disablePadding: false,
    disableSorting: true,
    label: "Payment document",
  },
  {
    id: "utrDate",
    numeric: true,
    disablePadding: false,
    disableSorting: true,
    label: "UTR date",
  },
  {
    id: "utrNo",
    numeric: true,
    disablePadding: false,
    disableSorting: true,
    label: "UTR No",
  },
  {
    id: "utrAmount",
    numeric: true,
    disablePadding: false,
    disableSorting: true,
    label: "UTR amount",
  },
];

export default function PoDetailsHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        <TableCell
          style={{
            backgroundColor: "rgb(155 209 242)",
            color: "black",
            padding: "6px",
            height: "50px",
          }}
        />
        {headCells.map((headCell) => (
          <TableCell
            style={{
              backgroundColor: "rgb(155 209 242)",
              color: "black",
              padding: "6px",
              height: "50px",
            }}
            key={headCell.id}
            align="left"
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              // hidden
              disabled={headCell.disableSorting}
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id && (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              )}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

PoDetailsHead.propTypes = {
  onRequestSort: PropTypes.func,
  order: PropTypes.string,
  orderBy: PropTypes.any,
};
